import { render, staticRenderFns } from "./Lists.vue?vue&type=template&id=2778ff31&"
import script from "./Lists.vue?vue&type=script&lang=js&"
export * from "./Lists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports